import { createAction, props } from '@ngrx/store';

import { MeetingActions } from './meeting.const';
import {
  AgendaDecisionStatus,
  MeetingAdditionalInfo,
  Document,
  MeetingContent,
  MeetingPrimaryActions,
  MeetingSidebar,
  MeetingOptionsMenuActions,
  MeetingItem
} from './meeting.models';
import { ClosableDateOption, MeetingContentCriteria } from './meeting.types';

import { ListOption } from '~/repositories/widgets/store/widgets.models';
import { DetailHeader } from '~/ui/detail/detail-header/detail-header.types';

export const fetchMeetingHeader = createAction(MeetingActions.fetchMeetingHeader, props<{ id: string }>());
export const fetchMeetingHeaderSuccess = createAction(
  MeetingActions.fetchMeetingHeaderSuccess,
  props<{ data: DetailHeader }>()
);
export const fetchMeetingHeaderFailure = createAction(
  MeetingActions.fetchMeetingHeaderFailure,
  props<{ error: any }>()
);

export const updateMeetingHeader = createAction(
  MeetingActions.updateMeetingHeader,
  props<{ id: string; data: DetailHeader }>()
);
export const updateMeetingHeaderSuccess = createAction(
  MeetingActions.updateMeetingHeaderSuccess,
  props<{ data: DetailHeader }>()
);
export const updateMeetingHeaderFailure = createAction(
  MeetingActions.updateMeetingHeaderFailure,
  props<{ error: any }>()
);

export const fetchMeetingContent = createAction(
  MeetingActions.fetchMeetingContent,
  props<{ id: string; criteria: MeetingContentCriteria; prevMeetingItems?: MeetingItem[] }>()
);
export const fetchMeetingContentSuccess = createAction(
  MeetingActions.fetchMeetingContentSuccess,
  props<{ data: MeetingItem[] }>()
);
export const fetchMeetingContentFailure = createAction(
  MeetingActions.fetchMeetingContentFailure,
  props<{ error: any }>()
);

export const fetchMeetingSidebar = createAction(MeetingActions.fetchMeetingSidebar, props<{ id: string }>());
export const fetchMeetingSidebarSuccess = createAction(
  MeetingActions.fetchMeetingSidebarSuccess,
  props<{ data: MeetingSidebar }>()
);
export const fetchMeetingSidebarFailure = createAction(
  MeetingActions.fetchMeetingSidebarFailure,
  props<{ error: any }>()
);

export const fetchMeetingPrimaryActions = createAction(
  MeetingActions.fetchMeetingPrimaryActions,
  props<{ id: string }>()
);
export const fetchMeetingPrimaryActionsSuccess = createAction(
  MeetingActions.fetchMeetingPrimaryActionsSuccess,
  props<{ data: MeetingPrimaryActions }>()
);
export const fetchMeetingPrimaryActionsFailure = createAction(
  MeetingActions.fetchMeetingPrimaryActionsFailure,
  props<{ error: any }>()
);

export const fetchMeetingOptionsMenu = createAction(
  MeetingActions.fetchMeetingOptionsMenuActions,
  props<{ id: string }>()
);
export const fetchMeetingOptionsMenuSuccess = createAction(
  MeetingActions.fetchMeetingOptionsMenuActionsSuccess,
  props<{ data: MeetingOptionsMenuActions }>()
);
export const fetchMeetingOptionsMenuFailure = createAction(
  MeetingActions.fetchMeetingOptionsMenuActionsFailure,
  props<{ error: any }>()
);

export const updateMeetingAdditionalInfo = createAction(
  MeetingActions.updateMeetingAdditionalInfo,
  props<{ meetingId: string; data: MeetingAdditionalInfo }>()
);

export const updateMeetingAdditionalInfoSuccess = createAction(
  MeetingActions.updateMeetingAdditionalInfo,
  props<{ data: MeetingAdditionalInfo }>()
);
export const updateMeetingAdditionalInfoFailure = createAction(
  MeetingActions.updateMeetingAdditionalInfoFailure,
  props<{ error: any }>()
);

export const addMeetingAttachment = createAction(MeetingActions.addMeetingAttachment, props<{ data: Document }>());

export const removeMeetingAttachment = createAction(
  MeetingActions.removeMeetingAttachment,
  props<{ meetingId: string; attachmentId: string }>()
);
export const removeMeetingAttachmentSuccess = createAction(
  MeetingActions.removeMeetingAttachmentSuccess,
  props<{ id: string }>()
);
export const removeMeetingAttachmentFailure = createAction(
  MeetingActions.removeMeetingAttachmentFailure,
  props<{ error: any }>()
);

export const fetchMoveMeetingItemOrgans = createAction(
  MeetingActions.fetchMoveMeetingItemOrgans,
  props<{
    meetingId: string;
  }>()
);
export const fetchMoveMeetingItemOrgansSuccess = createAction(
  MeetingActions.fetchMoveMeetingItemOrgansSuccess,
  props<{
    data: ListOption[];
  }>()
);
export const fetchMoveMeetingItemOrgansFailure = createAction(
  MeetingActions.fetchMoveMeetingItemOrgansFailure,
  props<{
    error: any;
  }>()
);

export const fetchMoveMeetingItemDates = createAction(
  MeetingActions.fetchMoveMeetingItemDates,
  props<{
    meetingId: string;
    organId: string;
  }>()
);
export const fetchMoveMeetingItemDatesSuccess = createAction(
  MeetingActions.fetchMoveMeetingItemDatesSuccess,
  props<{
    data: ClosableDateOption[];
  }>()
);
export const fetchMoveMeetingItemDatesFailure = createAction(
  MeetingActions.fetchMoveMeetingItemDatesFailure,
  props<{
    error: any;
  }>()
);

export const fetchAgendaDecisionStatusOptions = createAction(MeetingActions.fetchAgendaDecisionStatusOptions);
export const fetchAgendaDecisionStatusOptionsSuccess = createAction(
  MeetingActions.fetchAgendaDecisionStatusOptionsSuccess,
  props<{
    data: AgendaDecisionStatus[];
  }>()
);
export const fetchAgendaDecisionStatusOptionsFailure = createAction(
  MeetingActions.fetchAgendaDecisionStatusOptionsFailure,
  props<{
    error: any;
  }>()
);
